<div *ngIf="anyMessages" class="message_box {{ levelClass }}">
  <ul>
    <li *ngFor="let message of messages">{{ message }}</li>
  </ul>
</div>
